import { config } from './config';

const storageKey = 'REGULAR_FCFS_DESIGN_OPT_OUT';
const targetLocation = window.parent.location;

function createNewUrl(params: { networkPointId?: number } = {}) {
    return `${config.appBaseUrl}/transport/fcfs-booking/regular${
        params.networkPointId ? '?networkPointId=' + params.networkPointId : ''
    }`;
}

function goToNewDesign(params: { networkPointId?: number } = {}) {
    targetLocation.replace(createNewUrl(params));
}

export const migratedRegularFcfsProcess = {
    isActive: localStorage.getItem(storageKey) === null,
    activate(params: { networkPointId?: number } = {}) {
        localStorage.removeItem(storageKey);
        goToNewDesign(params);
    },
    goToNewDesign,
    createNewUrl
};
